import { render, staticRenderFns } from "./SimpleSiderLayout.vue?vue&type=template&id=b84f6034"
import script from "./SimpleSiderLayout.vue?vue&type=script&lang=js"
export * from "./SimpleSiderLayout.vue?vue&type=script&lang=js"
import style0 from "./SimpleSiderLayout.vue?vue&type=style&index=0&id=b84f6034&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports